import { encode } from 'he'

export const empty = []

export const keys = {
    9: 'tab',
    13: 'enter',
    27: 'esc',
    38: 'up',
    40: 'down'
}

export const getOptionId = (...args) => unoptionize(...args)?.id

export const optionize = type => result => ({
    [type]: result,
    type
})

export const unoptionize = ({ type, ...option }) => ({ ...option?.[type], type })

export const jsonMapper = ({ name, salt }) => shares =>
    shares.flatMap(({ type, ...share }, index) => {
        if(!share[type]) {
            share[type] = share
        }

        const { id } = share[type]

        return [
            {
                name: `${name}[${index}][type]`,
                value: type,
                key: `${salt}:value:type:${id}:${index}`
            },
            {
                name: `${name}[${index}][id]`,
                value: id,
                key: `${salt}:value:id:${id}:${index}`
            }
        ]
    })

export const multipartMapper = ({ name, salt }) => shares => {
    const values = shares.flatMap(({ type, ...share }) => {
        if(!share[type]) {
            share[type] = share
        }

        return {
            type,
            id: share[type].id
        }
    })

    const value = `encoded:${encode(JSON.stringify(values))}`

    return [{
        name,
        value,
        key: `${salt}:value`
    }]
}